import {
  has_freight_quantity,
  get_total,
  sum_breakdown,
} from "./voyage_account_util";
import moment from "moment";
import users from "./users";

function get_unduplicate_array_by_prop(vessel_accounts, prop) {
  let arr = [];
  if (prop == "charterer" || prop == "creator") {
    vessel_accounts.forEach((va) => {
      if (arr.indexOf(va[prop]) == -1) {
        arr.push(va[prop]);
      }
    });
  }
  if (prop == "creator") {
    arr = arr.map((a) => {
      return users.find((u) => u.id == a).name;
    });
  }
  if (prop == "cargo") {
    vessel_accounts.forEach((va) => {
      if (has_freight_quantity(va)) {
        va.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (arr.indexOf(bd.item_name) == -1 && bd.calc_type == "two") {
                  arr.push(bd.item_name);
                }
              });
            }
          });
        });
      } else {
        va.bl.forEach((bl) => {
          if (arr.indexOf(bl[prop]) == -1) {
            arr.push(bl[prop]);
          }
        });
      }
    });
  }
  if (prop == "bl") {
    vessel_accounts.forEach((va) => {
      if (has_freight_quantity(va)) {
        va.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (arr.indexOf(moment(bd.bl_date).format("YYYY/MM")) == -1) {
                  arr.push(moment(bd.bl_date).format("YYYY/MM"));
                }
              });
            }
          });
        });
      } else {
        va.bl.forEach((bl) => {
          if (arr.indexOf(moment(bl.date).format("YYYY/MM")) == -1) {
            arr.push(moment(bl.date).format("YYYY/MM"));
          }
        });
      }
    });
    arr.sort((a, b) => moment(a).diff(moment(b)));
  }
  if (prop == "voyage_year") {
    vessel_accounts.forEach((va) => {
      if (arr.indexOf(va[prop]) == -1) {
        arr.push(va[prop]);
      }
    });
  }
  if (prop == "bl_yr") {
    vessel_accounts.forEach((va) => {
      if (has_freight_quantity(va)) {
        va.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (arr.indexOf(moment(bd.bl_date).format("YYYY")) == -1) {
                  arr.push(moment(bd.bl_date).format("YYYY"));
                }
              });
            }
          });
        });
      } else {
        va.bl.forEach((bl) => {
          if (arr.indexOf(moment(bl.date).format("YYYY")) == -1) {
            arr.push(moment(bl.date).format("YYYY"));
          }
        });
      }
    });
    arr.sort((a, b) => moment(a).diff(moment(b)));
  }
  return arr;
}
function get_granularized_vessel_info(vessel_accounts) {
  let result = [];
  vessel_accounts.forEach((va) => {
    if (has_freight_quantity(va)) {
      va.accounts[1].sub_accounts.forEach((sub) => {
        if (sub.hasOwnProperty("is_freight")) {
          let total_pl = get_total(va, "debit") - get_total(va, "credit");
          let total_quatity = sub.breakdown.reduce((acc, bd) => {
            if (bd.calc_type == "two") {
              return (acc += parseFloat(bd.value_TONS));
            } else {
              return acc;
            }
          }, 0);
          sub.breakdown.forEach((bd) => {
            if (bd.calc_type == "two") {
              result.push({
                voyage_year: va.voyage_year,
                cargo: bd.item_name,
                creator: users.find((u) => u.id == va.creator).name,
                charterer: va.charterer,
                bl: moment(bd.bl_date).format("YYYY/MM"),
                bl_yr: moment(bd.bl_date).format("YYYY"),
                quantity: parseFloat(bd.value_TONS),
                pl: total_pl * (bd.value_TONS / total_quatity),
              });
            }
          });
        }
      });
    } else {
      let total_pl = get_total(va, "debit") - get_total(va, "credit");
      let total_quatity = va.bl.reduce((acc, bl) => {
        return (acc += parseFloat(bl.quantity));
      }, 0);
      va.bl.forEach((bl) => {
        result.push({
          voyage_year: va.voyage_year,
          cargo: bl.cargo,
          creator: users.find((u) => u.id == va.creator).name,
          charterer: va.charterer,
          bl: moment(bl.date).format("YYYY/MM"),
          bl_yr: moment(bl.date).format("YYYY"),
          quantity: parseFloat(bl.quantity),
          pl: total_pl * (bl.quantity / total_quatity),
        });
      });
    }
  });
  return result;
}
function two_dimen_calc(data, prop1, value1, prop2, value2, quantity_or_pl) {
  let result = 0;
  data.forEach((d) => {
    if (d[prop1] == value1 && d[prop2] == value2) {
      result += d[quantity_or_pl];
    }
  });
  return result;
}

function one_dimen_calc(data, prop, value, quantity_or_pl) {
  let result = 0;
  data.forEach((d) => {
    if (d[prop] == value) {
      result += d[quantity_or_pl];
    }
  });
  return result;
}

function get_vessel_accounts_by_prop(vessel_accounts, prop, value) {
  let vas = [];
  if (prop == "charterer") {
    vas = [...vessel_accounts].filter((va) => va[prop] == value);
  }
  if (prop == "creator") {
    let uid = users.find((u) => u.name == value).id;
    vas = [...vessel_accounts].filter((va) => va[prop] == uid);
  }
  if (prop == "cargo") {
    vas = [...vessel_accounts].filter((va) => {
      if (has_freight_quantity(va)) {
        let is_right_cargo = false;
        va.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (bd.item_name == value) {
                  is_right_cargo = true;
                }
              });
            }
          });
        });
        return is_right_cargo;
      } else {
        return va.bl.some((bl) => bl[prop] == value);
      }
    });
  }
  if (prop == "bl") {
    vas = [...vessel_accounts].filter((va) => {
      if (has_freight_quantity(va)) {
        return va.accounts.some((account) => {
          return account.sub_accounts.some((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              return sub_account.breakdown.some((bd) => {
                return moment(bd.bl_date).format("YYYY/MM") == value;
              });
            }
          });
        });
      } else {
        return va.bl.some((bl) => moment(bl.date).format("YYYY/MM") == value);
      }
    });
  }
  return vas;
}
function vessel_account_reducer_by_prop(
  vessel_accounts,
  quantity_or_blance,
  prop,
  value
) {
  let result = 0;
  if (prop == "creator" || prop == "charterer") {
    result = vessel_accounts.reduce((acc, va) => {
      return (acc += get_quantity_or_blance(
        va,
        quantity_or_blance,
        prop,
        value
      ));
    }, 0);
  }
  if (prop == "cargo") {
    result = vessel_accounts.reduce((acc, va) => {
      if (has_freight_quantity(va)) {
        va.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (bd.item_name == value) {
                  acc += get_quantity_or_blance(
                    va,
                    quantity_or_blance,
                    prop,
                    value
                  );
                }
              });
            }
          });
        });
      } else {
        va.bl.forEach((bl) => {
          if (bl[prop] == value) {
            acc += get_quantity_or_blance(va, quantity_or_blance, prop, value);
          }
        });
      }
      return acc;
    }, 0);
  }
  if (prop == "bl") {
    result = vessel_accounts.reduce((acc, va) => {
      if (has_freight_quantity(va)) {
        va.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (moment(bd.bl_date).format("YYYY/MM") == value) {
                  acc += get_quantity_or_blance(va, quantity_or_blance);
                }
              });
            }
          });
        });
      } else {
        va.bl.forEach((bl) => {
          if (moment(bl.date).format("YYYY/MM") == value) {
            acc += get_quantity_or_blance(va, quantity_or_blance);
          }
        });
      }
      return acc;
    }, 0);
  }
  return result;
}
function get_quantity_or_blance(
  vessel_account,
  quantity_or_blance,
  prop,
  value
) {
  let result = 0;
  if (prop == "creator" || prop == "charterer") {
    if (quantity_or_blance == "quantity") {
      if (has_freight_quantity(vessel_account)) {
        vessel_account.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (bd.item_name == value) {
                  result += parseFloat(bd.value_TONS);
                }
              });
            }
          });
        });
      } else {
        vessel_account.bl.forEach((bl) => {
          result += parseFloat(bl.quantity);
        });
      }
    }
    if (quantity_or_blance == "blance") {
      result =
        get_total(vessel_account, "debit") -
        get_total(vessel_account, "credit");
    }
  }
  if (prop == "cargo") {
    if (quantity_or_blance == "quantity") {
      if (has_freight_quantity(vessel_account)) {
        vessel_account.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (bd.item_name == value) {
                  result += parseFloat(bd.value_TONS);
                }
              });
            }
          });
        });
      } else {
        vessel_account.bl.forEach((bl) => {
          result += parseFloat(bl.quantity);
        });
      }
    }
    if (quantity_or_blance == "blance") {
      result =
        get_total(vessel_account, "debit") -
        get_total(vessel_account, "credit");
    }
  }
  if (prop == "bl") {
    if (quantity_or_blance == "quantity") {
      if (has_freight_quantity(vessel_account)) {
        vessel_account.accounts.forEach((account) => {
          account.sub_accounts.forEach((sub_account) => {
            if (sub_account.hasOwnProperty("is_freight")) {
              sub_account.breakdown.forEach((bd) => {
                if (moment(bd.bl_date).format("YYYY/MM") == value) {
                  result += parseFloat(bd.value_TONS);
                }
              });
            }
          });
        });
      } else {
        vessel_account.bl.forEach((bl) => {
          if (moment(bl.date).format("YYYY/MM") == value) {
            result += parseFloat(bl.quantity);
          }
        });
      }
    }
    if (quantity_or_blance == "blance") {
      result =
        get_total(vessel_account, "debit") -
        get_total(vessel_account, "credit");
    }
  }
  return result;
}

export {
  get_granularized_vessel_info,
  get_unduplicate_array_by_prop,
  get_vessel_accounts_by_prop,
  vessel_account_reducer_by_prop,
  two_dimen_calc,
  one_dimen_calc,
};
